import { Injectable, inject, signal } from '@angular/core';
import { Api } from '@/app/core/api/api';
import { grantedOperation } from '@/app/core/api/fn/authorization/granted-operation';

@Injectable({ providedIn: 'root' })
/* v8 ignore start */
export class GrantedOperationService {
/* v8 ignore stop */
    private readonly api = inject(Api);
    private readonly codes = signal<ReadonlySet<string>>(new Set());
    private pending: Promise<void> | null = null;

    has(operation: string): boolean {
        return this.codes().has(operation) || this.codes().has(operation.replace(/:list$/, ':searchByQueryMunicipality'));
    }

    granted(): ReadonlySet<string> {
        return this.codes();
    }

    ensureLoaded(): Promise<void> {
        if (this.pending) {
            return this.pending;
        }
        this.pending = this.api
            .invoke(grantedOperation)
            .then((response) => {
                const codes = (response.content ?? []).map((item) => item.code).filter((code): code is string => !!code);
                this.codes.set(new Set(codes));
            })
            .catch(() => {
                this.codes.set(new Set());
            });
        return this.pending;
    }
}
